import React from 'react'
import ProjectCard from './ProjectCard'
import inventory from '../images/inventory.png'
import career from '../images/career.png'
import twitter from '../images/twitter.png'
import dorm from '../images/dormdine.png'



import { CSSTransition } from 'react-transition-group';

import '../Responsive.css'

const MyProjects = () => {

  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  const projects = [
    {
      id: 1,
      imageSrc: career,
      title: 'Career Counselling System',
      stack: 'Python|| MySQL',
      description: 'A Destop application which  includes functionalities like conduction of test and provide suggestion on which career to choose based on the graphs',
      githubLink: 'https://github.com/Sarvadnyaawaghad150503/Career-Counselling-System',

    },
    {
      id: 2,
      imageSrc: inventory,
      title: 'Inventory Managemeent System',
      stack: 'JAVA || MySQL || PhpMyAdmin',
      description: 'This system can simplify the process of ordering, storing and printing reciept in a well defined manner',
      githubLink: 'https://github.com/Sarvadnyaawaghad150503/INVENTORY-MANAGEMENT-SYSTEM',

    },
    {
      id: 3,
      imageSrc: dorm,
      title: 'Dorm Dine',
      stack: 'MongoDB ExpressJs ReactJs NodeJs ',
      description: ' A full-stack web app for property rentals and dining services with interactive user-interfaces, advanced search, and secure authentication',
      githubLink: 'https://github.com/Sarvadnyaawaghad150503/DormDine_FInal',
      // demoLink: 'https://twitter-clone-39rgcinrc-sarvadnyaawaghad150503.vercel.app/',

    },
    {
      id: 4,
      imageSrc: twitter,
      title: 'Twitter Clone',
      stack: 'React || Tailwind CSS ',
      description: 'A clone of twitter components on a single page web application',
      githubLink: 'https://github.com/Sarvadnyaawaghad150503/Twitter-Clone',
      // demoLink: 'https://twitter-clone-39rgcinrc-sarvadnyaawaghad150503.vercel.app/',

    }
    // {
    //   id: 5,
    //   imageSrc: blog,
    //   title: "Let's Blog",
    //   stack: 'MongoDB ExpressJs ReactJs NodeJs ',
    //   description: 'Description of Project 1',
    //   githubLink: 'https://github.com/Sarvadnyaawaghad150503/Twitter-Clone',
    //   demoLink: 'https://twitter-clone-39rgcinrc-sarvadnyaawaghad150503.vercel.app/',

    // },


  ]

  return (
    <div className='w-full text-white pt-10'>
      <div className="text-4xl font-serif m-4 relative ml-8 text-center">
        <h2 className="inline-block transform transition-transform duration-100 hover:scale-125">MY PROJECTS</h2>
        {/* <span className="absolute left-0 bottom-0 w-0 h-1 bg-white  transition-all duration-300 origin-left hover:w-full"></span> */}
      </div>


      <CSSTransition in={isMounted} timeout={1500} classNames='custom'>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mx-auto max-w-7xl px-4 mb-16">
          {projects.map((project) => (
            <ProjectCard
              key={project.id}
              imageSrc={project.imageSrc}
              title={project.title}
              stack={project.stack}
              description={project.description}
              githubLink={project.githubLink}
              demoLink={project.demoLink}
            />
          ))}
        </div>
      </CSSTransition>
    </div>
  )
}

export default MyProjects